import React, { useRef, useState } from 'react';
import { getClassNameFactory, Button } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import { IVideoTabList } from '../../types';
import './VideoTabList.css';
import { IVideoPlaylistDetail } from '../../../../types';

export const VideoTabList: React.FC<IVideoTabList> = (props) => {
  const getClassName = getClassNameFactory(VideoTabList.displayName);
  const { playListUserData, currentVideoHandler } = props;
  const [currentId, setCurrentId] = useState(playListUserData[0].entry_id);

  const currentIdHandler = (id: string) => {
    setCurrentId(id);
  };

  const tabListRef = useRef<HTMLDivElement>(null);

  const changeTabPanel = (currentListItem: IVideoPlaylistDetail) => {
    currentVideoHandler(currentListItem);
    currentIdHandler(currentListItem.entry_id);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    const tabList = tabListRef.current;
    if (!tabList) return;

    const items: HTMLElement[] = Array.from(
      tabList.querySelectorAll('span[role=tab]')
    );

    let currentIndex = items.indexOf(event.currentTarget);

    if (event.key === 'ArrowDown') {
      const nextIndex = (currentIndex + 1) % items?.length;
      items[nextIndex].focus();
    } else if (event.key === 'ArrowUp') {
      if (currentIndex === 0) {
        currentIndex = items.length;
      }
      const prevIndex = (currentIndex - 1) % items?.length;
      items[prevIndex].focus();
    }
  };

  return (
    <div className={getClassName()} {...propsToDataAttributes(props)}>
      <div role="tablist" aria-orientation="vertical" ref={tabListRef}>
        {playListUserData.map((listItem) => (
          <div key={listItem.entry_id}>
            <Button
              kind={ButtonKind.LINK}
              color={ButtonColor.TERTIARY}
              onClick={() => {
                changeTabPanel(listItem);
              }}
              role="tab"
              ariaSelected={listItem.entry_id === currentId}
              aria-controls={listItem.entry_id}
              tabIndex={listItem.entry_id === currentId ? 0 : -1}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  changeTabPanel(listItem);
                } else {
                  handleKeyPress(e);
                }
              }}
              disabled={false}
              active={listItem.entry_id === currentId}
              id={listItem.entry_id}
              data-testid="video-tab-list"
            >
              {listItem.videoData?.videoTitle}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

VideoTabList.displayName = 'VideoTabList';
